import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { EmptyControl, Nested, Required } from '@hvlng/framework-bff/core';
import { HvlQueryModel } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { PerObjectDefinitionQueryModel } from './per-object-definition-query-model';

@JsonObject('KovanHrPositionLookupModel')
export class PositionLookupModel {

    @EmptyControl()
    @JsonProperty('perObjectDefinitionId', Number, true)
    perObjectDefinitionId: number = null;

    @EmptyControl()
    @JsonProperty('degreeOfCadre', Number, true)
    degreeOfCadre: number = null;

    @EmptyControl()
    @JsonProperty('objectCode', String, true)
    objectCode: string = null;

    @EmptyControl()
    @JsonProperty('longText', String, true)
    longText: string = null;

    @EmptyControl()
    @JsonProperty('errorStatus', Boolean, true)
    errorStatus: boolean = false;

    @EmptyControl()
    @JsonProperty('perEmployeeType', String, true)
    perEmployeeType: String = null;

    @EmptyControl()
    @JsonProperty('perEmployeeSubtype', String, true)
    perEmployeeSubtype: String = null;
}
